import React, { memo } from 'react';
import { ICON_SIZES, EVENODD, COLOR_TYPES } from '../constants';
export var KitIcon = memo(function (_a) {
    var _b = _a.colorType, colorType = _b === void 0 ? 'richGreyColor' : _b, _c = _a.size, size = _c === void 0 ? 'M' : _c, paths = _a.paths, viewBox = _a.viewBox;
    return (React.createElement("svg", { fill: "none", height: ICON_SIZES[size], viewBox: viewBox, width: ICON_SIZES[size], xmlns: "http://www.w3.org/2000/svg" }, paths.map(function (path) { return (React.createElement("path", { key: path, clipRule: EVENODD, d: path, 
        // fill={`var(--icon-fill, ${COLOR_TYPES[colorType]})`}
        fill: COLOR_TYPES[colorType], fillRule: EVENODD })); })));
});
